import localeText from "../locale";
import AreaManagerService from "../service/Cadastros/AreaManagerService";
import SpecialCustomerService from "../service/Cadastros/SpecialCustomerService";
import GetInfoService from "../service/GetInfoService";
import SalePromoterService from "../service/Cadastros/SalePromoterService";
import ProductService from "../service/ProductService";
import BusinessPartnerService from "../service/Cadastros/BusinessPartnerService";
import SellerService from "../service/Cadastros/SellerService";
import StoreService from "../service/Cadastros/StoreService";

export default class ValidateUserInfo {
  constructor(
    toast,
    emailRef,
    emailRefResponsive,
    setEmail,
    findUsername,
    findReferral,
    docnumberRef,
    docnumberRefResponsive,
    setDocumentNumber,
    setLoading,
    setUserState = null,
    setPriceForex = null,
    setDisplayPaymentModal = null
  ) {
    this.toast = toast;
    this.emailRef = emailRef;
    this.emailRefResponsive = emailRefResponsive;
    this.setEmail = setEmail;
    this.findUsername = findUsername;
    this.findReferral = findReferral;
    this.docnumberRef = docnumberRef;
    this.docnumberRefResponsive = docnumberRefResponsive;
    this.setDocumentNumber = setDocumentNumber;
    this.setUserState = setUserState;
    this.setPriceForex = setPriceForex;
    this.setDisplayPaymentModal = setDisplayPaymentModal;
    this.setLoading = setLoading;

    this.specialCustomerService = new SpecialCustomerService();
    this.getInfoService = new GetInfoService();
    this.areaManagerService = new AreaManagerService();
    this.salePromoterService = new SalePromoterService();
    this.sellerService = new SellerService();
    this.productService = new ProductService();
    this.storeService = new StoreService();
  }

  validateCPF(cpf) {
    // eslint-disable-next-line no-useless-escape
    let regexCPF = /[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}/;

    if (!new RegExp(regexCPF).test(cpf)) return false;

    let regexOnlyNumbers = /^[0-9]+$/;

    if (!new RegExp(regexOnlyNumbers).test(cpf)) cpf = cpf.replace(/\D/g, "");

    let soma;
    let resto;

    soma = 0;
    if (cpf === "00000000000") return false;

    for (let i = 1; i <= 9; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
    resto = (soma * 10) % 11;

    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(9, 10))) return false;

    soma = 0;
    for (let i = 1; i <= 10; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;

    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(10, 11))) return false;

    return cpf;
  }

  validateCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, "");

    if (cnpj === "") {
      return false;
    }

    if (cnpj.length !== 14) {
      return false;
    }

    // Elimina CNPJs invalidos conhecidos
    if (
      cnpj === "00000000000000" ||
      cnpj === "11111111111111" ||
      cnpj === "22222222222222" ||
      cnpj === "33333333333333" ||
      cnpj === "44444444444444" ||
      cnpj === "55555555555555" ||
      cnpj === "66666666666666" ||
      cnpj === "77777777777777" ||
      cnpj === "88888888888888" ||
      cnpj === "99999999999999"
    ) {
      return false;
    }

    // Valida DVs
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }

    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitos.charAt(0))) {
      return false;
    }

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitos.charAt(1))) {
      return false;
    }

    return cnpj;
  }

  validatePartitaIVA(pi) {
    if (pi === "") return false;
    else if (!/^[0-9]{11}$/.test(pi)) return false;
    else {
      var s = 0;
      for (let i = 0; i <= 9; i += 2) {
        s += parseInt(pi.charCodeAt(i) - "0".charCodeAt(0));
      }
      for (let i = 1; i <= 9; i += 2) {
        var c = 2 * parseInt(pi.charCodeAt(i) - "0".charCodeAt(0));
        if (c > 9) c = c - 9;
        s += c;
      }
      var controllo = (10 - (s % 10)) % 10;
      if (controllo !== parseInt(pi.charCodeAt(10) - "0".charCodeAt(0))) return false;
      else return true;
    }
  }

  validateCodiceFiscale(cfins) {
    let cf = cfins.toUpperCase();
    let cfReg = /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/;

    if (!cfReg.test(cf)) {
      return false;
    }

    let set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX";
    let s = 0;

    for (let i = 1; i <= 13; i += 2) s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
    for (let i = 0; i <= 14; i += 2) s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
    if (s % 26 !== cf.charCodeAt(15) - "A".charCodeAt(0)) return false;

    return true;
  }

  validateNIN(nin) {
    const regexNIN =
      /^(?!BG)(?!GB)(?!NK)(?!KN)(?!TN)(?!NT)(?!ZZ)(?:[A-CEGHJ-PR-TW-Z][A-CEGHJ-NPR-TW-Z])(?:\s*\d\s*){6}([A-D]|\s)$/;

    nin = nin.trim().toUpperCase();

    return !new RegExp(regexNIN).test(nin) ? false : true;
  }

  validateEmailRegex = (email) => {
    return email.match(
      // eslint-disable-next-line no-useless-escape
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  async validateEmail(email, responsive) {
    email = email.trim();
    if (!this.validateEmailRegex(email)) {
      this.toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("pleaseEnterValidEmail"),
        life: 6000,
      });
      return false;
    } else {
      try {
        const res = await this.getInfoService.getFindEmail(email);

        if (res.messageCode !== 200001) {
          this.toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("thereIsAnExisting"),
            life: 6000,
          });

          if (!responsive) this.emailRef.current.style.border = "1px solid red";
          else this.emailRefResponsive.current.style.border = "1px solid red";

          return false;
        } else {
          this.setEmail(email);
          return true;
        }
      } catch (e) {
        console.log(e);
      }
    }
  }

  validatePassword = (password) => {
    // Minimum password length validation
    if (password.length < 6) return 1;
    // Maximum password length validation
    if (password.length > 18) return 2;
    // Alphanumeric and - _ validation
    if (!/^[a-zA-Z0-9-_]+$/.test(password)) return 3;
    else return 4;
  };

  async validateUsername(username, responsive) {
    // No whitespace validation
    username = username.trim();

    if (/\s/.test(username)) {
      this.toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("usernameWhitespace"),
        life: 6000,
      });
      return false;
    } else if (!/^[A-Za-z0-9]*$/.test(username)) {
      this.toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("noSpecialCharacters"),
        life: 6000,
      });
      return false;
    } else {
      return this.findUsername(username, responsive);
    }
  }

  async validateDocumentNumber(documentNumber, responsive, country, pj) {
    try {
      let res;
      if (country === "BR")
        res = await this.getInfoService.getFindDocumentNumber(
          documentNumber.replace(/[^\d]+/g, "")
        );
      else res = await this.getInfoService.getFindDocumentNumber(documentNumber);

      if (res.messageCode !== 200001) {
        this.toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("thereIsAnDocNumber"),
          life: 6000,
        });

        if (!responsive) this.docnumberRef.current.style.border = "1px solid red";
        else this.docnumberRefResponsive.current.style.border = "1px solid red";

        return false;
      } else {
        // Validate CPF (Brazil private individual document code)
        if (country === "BR") {
          documentNumber = documentNumber.trim().toUpperCase();

          const cpfValidado = this.validateCPF(documentNumber);
          const cnpjValidado = this.validateCNPJ(documentNumber);

          if (cpfValidado) {
            this.setDocumentNumber(cpfValidado);
            return true;
          } else if (cnpjValidado) {
            this.setDocumentNumber(cnpjValidado);
            return true;
          } else {
            this.toast.current.show({
              severity: "error",
              summary: localeText("error"),
              detail: localeText("invalidDocumentNumber"),
              life: 6000,
            });
            return false;
          }
        }
        // Validate Codice Fiscale (Italy private individual document code)
        else if (country === "IT") {
          documentNumber = documentNumber.trim().toUpperCase();

          if (this.validateCodiceFiscale(documentNumber)) {
            this.setDocumentNumber(documentNumber);
            return true;
          } else if (this.validatePartitaIVA(documentNumber)) {
            this.setDocumentNumber(documentNumber);
            return true;
          } else {
            this.toast.current.show({
              severity: "error",
              summary: localeText("error"),
              detail: localeText("invalidDocumentNumber"),
              life: 6000,
            });
            return false;
          }
        } else if (country === "MX") {
          documentNumber = documentNumber.trim().toUpperCase();

          if (documentNumber !== "") {
            var patt = new RegExp(
              "^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9]?[A-Z,0-9]?[0-9,A-Z]?$"
            );
            if (patt.test(documentNumber)) {
              this.setDocumentNumber(documentNumber);
              return true;
            } else {
              this.toast.current.show({
                severity: "error",
                summary: localeText("error"),
                detail: localeText("invalidRFC"),
                life: 6000,
              });
              return false;
            }
          }
        } else if (country === "GB") {
          if (this.validateNIN(documentNumber)) {
            this.setDocumentNumber(documentNumber);
            return true;
          } else if (this.validatePartitaIVA(documentNumber)) {
            this.setDocumentNumber(documentNumber);
            return true;
          } else {
            this.toast.current.show({
              severity: "error",
              summary: localeText("error"),
              detail: localeText("invalidDocumentNumber"),
              life: 6000,
            });
            return false;
          }
        } else {
          this.setDocumentNumber(documentNumber);
          return true;
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  async registerSpecialCustomer(
    referee,
    username,
    email,
    documentNumber = null,
    fname,
    lname,
    password1,
    password2,
    language,
    currency,
    terms,
    marketingEmail,
    responsive,
    country,
    tokenRecaptcha,
    plan,
    coupon,
    internationalCode,
    localCode,
    phoneNumber,
    isMobile
  ) {
    this.setLoading(true);

    if (
      await this.validateInfo(
        referee,
        username,
        email,
        (documentNumber = null),
        fname,
        lname,
        password1,
        password2,
        language,
        currency,
        terms,
        marketingEmail,
        responsive,
        country,
        tokenRecaptcha,
        plan,
        coupon,
        internationalCode,
        localCode,
        phoneNumber,
        isMobile
      ).then((x) => !x)
    ) {
      this.setLoading(false);
      return false;
    }

    // if (country === 'BR')
    //   documentNumber = documentNumber.replace(/\D/g, '');

    try {
      let location;

      if (!localStorage.getItem("__extraconomy_lat__"))
        location = await this.getInfoService.getUserLocation();

      const res = await this.specialCustomerService.postRegisterSpecialCustomer(
        referee,
        username,
        email,
        documentNumber,
        fname,
        lname,
        password1,
        currency,
        language,
        coupon,
        country,
        internationalCode,
        localCode,
        phoneNumber,
        localStorage.getItem("__extraconomy_lat__")
          ? localStorage.getItem("__extraconomy_lat__")
          : location.latitude,
        localStorage.getItem("__extraconomy_long__")
          ? localStorage.getItem("__extraconomy_long__")
          : location.longitude
      );

      if (res.messageCode !== 200000) {
        this.toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        this.setLoading(false);
      } else {
        window.location.replace(
          "/emailconfirmation?title=" +
            localeText("emailConfirmationTitle") +
            "&message=" +
            localeText("emailConfirmationMessage") +
            "&type=success"
        );
      }
    } catch (e) {
      this.setLoading(false);
      console.log(e);
    }
  }

  async registerStore(
    referee,
    username,
    email,
    documentNumber = null,
    fname,
    lname,
    password1,
    password2,
    language,
    currency,
    terms,
    marketingEmail,
    responsive,
    country,
    tokenRecaptcha,
    plan,
    coupon,
    internationalCode,
    localCode,
    phoneNumber,
    isMobile
  ) {
    this.setLoading(true);

    if (
      await this.validateInfo(
        referee,
        username,
        email,
        (documentNumber = null),
        fname,
        lname,
        password1,
        password2,
        language,
        currency,
        terms,
        marketingEmail,
        responsive,
        country,
        tokenRecaptcha,
        plan,
        coupon,
        internationalCode,
        localCode,
        phoneNumber,
        isMobile
      ).then((x) => !x)
    ) {
      this.setLoading(false);
      return false;
    }

    try {
      let location;

      if (!localStorage.getItem("__extraconomy_lat__"))
        location = await this.getInfoService.getUserLocation();

      const res = await this.storeService.postRegisterStore(
        referee,
        username,
        email,
        documentNumber,
        fname,
        lname,
        password1,
        currency,
        language,
        coupon,
        country,
        internationalCode,
        localCode,
        phoneNumber,
        localStorage.getItem("__extraconomy_lat__")
          ? localStorage.getItem("__extraconomy_lat__")
          : location.latitude,
        localStorage.getItem("__extraconomy_long__")
          ? localStorage.getItem("__extraconomy_long__")
          : location.longitude
      );

      if (res.messageCode !== 200000) {
        this.toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        this.setLoading(false);
      } else {
        window.location.replace(
          "/emailconfirmation?title=" +
            localeText("emailConfirmationTitle") +
            "&message=" +
            localeText("emailConfirmationMessage") +
            "&type=success"
        );
      }
    } catch (e) {
      this.setLoading(false);
      console.log(e);
    }
  }

  async uploadImages(image) {
    try {
      if (image && typeof image !== "string") {
        const res = await this.productService.postUploadImage(
          localStorage.getItem("__extraconomy_token"),
          image
        );

        if (res.messageCode !== 200000) {
          this.toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
            life: 6000,
          });
          if (res.messageCode === 500000) console.log(res);
          return false;
        } else {
          return res.result;
        }
      } else {
        return null;
      }
    } catch (e) {
      if (e.status === 401) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      } else if (e.status === 500) {
        this.toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("unexpectedSystemBehaviour"),
          life: 6000,
        });
      } else {
        this.toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("unexpectedErrorUploadImg"),
          life: 6000,
        });
      }
    }
  }

  async registerSalePromoter(
    referee,
    username,
    email,
    documentNumber = null,
    fname,
    lname,
    password1,
    password2,
    language,
    currency,
    terms,
    marketingEmail,
    responsive,
    country,
    tokenRecaptcha,
    plan,
    internationalCode,
    localCode,
    phoneNumber
  ) {
    this.setLoading(true);

    if (
      await this.validateInfo(
        referee,
        username,
        email,
        (documentNumber = null),
        fname,
        lname,
        password1,
        password2,
        language,
        currency,
        terms,
        marketingEmail,
        responsive,
        country,
        tokenRecaptcha,
        plan,
        null,
        internationalCode,
        localCode,
        phoneNumber
      ).then((x) => !x)
    ) {
      this.setLoading(false);
      return false;
    }

    // if (country === 'BR')
    //   documentNumber = documentNumber.replace(/\D/g, '');

    try {
      let location;

      if (!localStorage.getItem("__extraconomy_lat__"))
        location = await this.getInfoService.getUserLocation();

      const res = await this.salePromoterService.postRegisterSalePromoter(
        referee,
        username,
        email,
        documentNumber,
        fname,
        lname,
        password1,
        currency,
        language,
        country,
        internationalCode,
        localCode,
        phoneNumber,
        localStorage.getItem("__extraconomy_lat__")
          ? localStorage.getItem("__extraconomy_lat__")
          : location.latitude,
        localStorage.getItem("__extraconomy_long__")
          ? localStorage.getItem("__extraconomy_long__")
          : location.longitude
      );

      if (res.messageCode !== 200000) {
        this.toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        if (res.messageCode === 500000) console.log(res);
        this.setLoading(false);
      } else {
        window.location.replace(
          "/emailconfirmation?title=" +
            localeText("emailConfirmationTitle") +
            "&message=" +
            localeText("emailConfirmationMessage") +
            "&type=success"
        );
      }
    } catch (e) {
      this.setLoading(false);
      console.log(e);
    }
  }

  async registerPaidPlan(
    referee,
    username,
    email,
    documentNumber = null,
    fname,
    lname,
    password1,
    password2,
    language,
    currency,
    terms,
    marketingEmail,
    responsive,
    plan,
    country,
    tokenRecaptcha,
    internationalCode,
    localCode,
    phoneNumber,
    voucher = null
  ) {
    this.setLoading(true);

    if (
      await this.validateInfo(
        referee,
        username,
        email,
        documentNumber,
        fname,
        lname,
        password1,
        password2,
        language,
        currency,
        terms,
        marketingEmail,
        responsive,
        country,
        tokenRecaptcha,
        plan,
        null,
        internationalCode,
        localCode,
        phoneNumber
      ).then((x) => !x)
    ) {
      this.setLoading(false);
      return false;
    }

    // if (country === 'BR')
    //   documentNumber = documentNumber.replace(/\D/g, '');

    const user = {
      referee: referee,
      username: username,
      email: email,
      documentNumber: documentNumber,
      fname: fname,
      lname: lname,
      password1: password1,
      password2: password2,
      language: language,
      currency: currency,
      terms: terms,
      marketingEmail: marketingEmail,
      plan: plan,
      country: country,
      internationalCode: internationalCode,
      localCode: localCode,
      phoneNumber: phoneNumber,
    };

    const resForex = await this.getInfoService.getForexRate(
      currency,
      process.env.REACT_APP_BASE_PAYPAL_CURRENCY
    );

    const basePrice = await this.getInfoService.getPlanListByCurrency(currency);

    const currentPlan = basePrice.result.find((item) => item.id === plan);
    const fullPricePlan =
      currentPlan.price + currentPlan.price * (currentPlan.taxOverPricePercentual / 100);

    if (currency !== process.env.REACT_APP_BASE_PAYPAL_CURRENCY)
      this.setPriceForex(parseFloat((fullPricePlan * resForex.result).toFixed(2)));
    else this.setPriceForex(parseFloat(fullPricePlan.toFixed(2)));

    if (!voucher) {
      this.setUserState(user);
      this.setDisplayPaymentModal(true);
      this.setLoading(false);
    } else {
      try {
        let location;

        if (!localStorage.getItem("__extraconomy_lat__"))
          location = await this.getInfoService.getUserLocation();

        let resVoucher;

        if (plan === 1) {
          const businessPartnerService = new BusinessPartnerService();

          resVoucher = await businessPartnerService.postRegisterBusinessPartner(
            referee,
            username,
            email,
            documentNumber,
            fname,
            lname,
            password1,
            currency,
            language,
            voucher,
            country,
            internationalCode,
            localCode,
            phoneNumber,
            localStorage.getItem("__extraconomy_lat__")
              ? localStorage.getItem("__extraconomy_lat__")
              : location.latitude,
            localStorage.getItem("__extraconomy_long__")
              ? localStorage.getItem("__extraconomy_long__")
              : location.longitude,
            2
          );
        } else if (plan === 2) {
          resVoucher = await this.areaManagerService.postRegisterAreaManager(
            referee,
            username,
            email,
            documentNumber,
            fname,
            lname,
            password1,
            currency,
            language,
            null,
            country,
            internationalCode,
            localCode,
            phoneNumber,
            localStorage.getItem("__extraconomy_lat__")
              ? localStorage.getItem("__extraconomy_lat__")
              : location.latitude,
            localStorage.getItem("__extraconomy_long__")
              ? localStorage.getItem("__extraconomy_long__")
              : location.longitude,
            voucher
          );
        } else if (plan === 4) {
          resVoucher = await this.sellerService.postRegisterSeller(
            referee,
            username,
            email,
            documentNumber,
            fname,
            lname,
            password1,
            currency,
            language,
            null,
            country,
            internationalCode,
            localCode,
            phoneNumber,
            localStorage.getItem("__extraconomy_lat__")
              ? localStorage.getItem("__extraconomy_lat__")
              : location.latitude,
            localStorage.getItem("__extraconomy_long__")
              ? localStorage.getItem("__extraconomy_long__")
              : location.longitude,
            voucher
          );
        }

        if (resVoucher.messageCode !== 200000) {
          this.toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resVoucher.messageCode).message,
            life: 6000,
          });
          if (resVoucher.messageCode === 500000) console.log(resVoucher);
          this.setLoading(false);
        } else {
          window.location.replace(
            "/emailconfirmation?title=" +
              localeText("emailConfirmationTitle") +
              "&message=" +
              localeText("emailConfirmationMessage") +
              "&type=success"
          );
        }
      } catch (e) {
        this.setLoading(false);
        console.log(e);
      }
    }
  }

  async validateInfo(
    referee,
    username,
    email,
    documentNumber = null,
    fname,
    lname,
    password1,
    password2,
    language,
    currency,
    terms,
    marketingEmail,
    responsive,
    country,
    tokenRecaptcha,
    plan,
    coupon,
    internationalCode,
    localCode,
    phoneNumber,
    isMobile
  ) {
    try {
      // ReCaptcha Token validation
      if (tokenRecaptcha.length === 0) {
        this.toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("pleaseReverify"),
          life: 6000,
        });
        return false;
      }
      // Matched passwords validation
      if (password1 !== password2) {
        this.toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("passwordFieldsMismatched"),
          life: 6000,
        });
        return false;
      }
      // No empty fields validation
      if (
        username.length === 0 ||
        email.length === 0 ||
        /** documentNumber.length === 0 || */ fname.length === 0 ||
        lname.length === 0 ||
        password1.length === 0 ||
        password2.length === 0 ||
        internationalCode.length === 0 ||
        phoneNumber.length === 0 ||
        (!isMobile && coupon && coupon.length === 0)
      ) {
        this.toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("pleaseFillOutAll"),
          life: 6000,
        });
        return false;
      }
      // Terms and conditions validation
      if (terms === false) {
        this.toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("pleaseAgreeTerms"),
          life: 6000,
        });
        return false;
      }
      // No short password validation
      if (this.validatePassword(password1) === 1) {
        this.toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("pleaseTypeLongerPassword"),
          life: 6000,
        });
        return false;
      }
      // No long password validation
      if (this.validatePassword(password1) === 2) {
        this.toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("pleaseTypeShorterPassword"),
          life: 6000,
        });
        return false;
      }
      // Password value validation
      if (this.validatePassword(password1) === 3) {
        this.toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("invalidPassword"),
          life: 6000,
        });
        return false;
      }
      // // plan is equal area manager and document number is not cnpj in BR
      // if (plan === 2 && country === 'BR' && !this.validateCNPJ(documentNumber)) {
      //   this.toast.current.show({
      //     severity: 'error',
      //     summary: localeText('error'),
      //     detail: localeText('invalidDocumentNumber'),
      //     life: 6000
      //   });
      //   return false;
      // }
      // //plan is area manager and document number is not partita iva in IT
      // if (plan === 2 && country === 'IT' && !this.validatePartitaIVA(documentNumber)) {
      //   this.toast.current.show({
      //     severity: 'error',
      //     summary: localeText('error'),
      //     detail: localeText('invalidDocumentNumber'),
      //     life: 6000
      //   });
      //   return false;
      // }
      // Username validation
      if (await this.validateUsername(username, responsive).then((x) => !x)) {
        return false;
      }
      // Referral validation
      if (await this.findReferral(referee, responsive).then((x) => !x)) {
        return false;
      }
      // Email validation
      if (await this.validateEmail(email, responsive).then((x) => !x)) {
        return false;
      }
      // Document Number validation
      // if (await this.validateDocumentNumber(documentNumber, responsive, country, plan === 2 ? true : false).then(x => !x)) {
      //   return false;
      // }

      return true;
    } catch (e) {
      console.log(e);
    }
  }
}
